import type { UserKycSession } from '@/features/kyc/types/kyc';
import SumsubWebSdk from '@sumsub/websdk-react';
import styles from './SumsubKycPage.module.scss';
import { useKyc } from '@/features/kyc/hooks/useKyc';

export interface SumsubKycPageProps {
  session: UserKycSession;
}

function SumsubKycPage({ session }: SumsubKycPageProps) {
  const { requestKycSession } = useKyc();

  const sumsubToken = session.token;

  const accessTokenExpirationHandler = async () => {
    const newSession = await requestKycSession();
    return newSession.session.token;
  };

  return (
    <div>
      <div className={styles.sumsubContainer}>
        <SumsubWebSdk
          accessToken={sumsubToken}
          expirationHandler={accessTokenExpirationHandler}
          config={{
            lang: 'ro',
            theme: 'light',
            documentDefinitions: {
              IDENTITY: {
                country: 'ROU',
                idDocType: 'ID_CARD',
              },
            },
            autoSelectDocumentDefinitions: true,
          }}
          options={{
            addViewportTag: false,
            adaptIframeHeight: true,
          }}
        />
      </div>
    </div>
  );
}

export default SumsubKycPage;
